export const PROJECTS_SUB_PAGES = {
  createProject: 'createProject',
  changelog: 'changelog',
};
